export interface ExpensePolicyDetailClass {
    AccountExpensePolicyCategoryId: number
    AccountExpensePolicyId: string
    AccountId: number
    AccountExpenseId: number
    AccountExpenseName: string
    IsOverride: boolean
    ExpenseAmountLimit: number
    ReceiptRequiredLimit: number
    IsDescriptionRequired: boolean
    CreatedByEmployeeId: number
    ModifiedOn:  Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    IsDisabledCategory: boolean
}

export const expensePolicyDetailInitialsForAdd = {
    AccountExpensePolicyId: "",
    IsOverride: false,
    AccountExpenseId: "",
    AccountExpenseName: "",
    ExpenseAmountLimit: 0,
    ReceiptRequiredLimit: 0,
    IsDescriptionRequired: false,
    PolicyAmountLimit: 0,
    PolicyRequiredLimit: 0,
    IsDisabled: false,
    PolicyDescriptionRequired: false,
    IsDisabledCategory: false


}
export const expensePolicyDetailInitialsForUpdate = {
    AccountExpensePolicyCategoryId: "",
    AccountExpensePolicyId: "",
    IsOverride: false,
    AccountExpenseId: "",
    AccountExpenseName: "",
    ExpenseAmountLimit: 0,
    ReceiptRequiredLimit: 0,
    IsDescriptionRequired: false,
    PolicyAmountLimit: 0,
    PolicyRequiredLimit: 0,
    IsDisabled: false,
    PolicyDescriptionRequired: false,
    IsDisabledCategory: false
}